import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from 'app/shared/utils';


@Pipe({
    name: 'toAgnosticDateString',
    standalone: true,
})
export class ToAgnosticDateStringPipe implements PipeTransform {

  transform(dt: Date | string, formatStr?: string): string {
    return DateUtils.getAgnosticDateString(dt, formatStr);
  }

}